import { afterNextRender, ElementRef, type Signal } from '@angular/core';

import { injectResizer } from '@cosmos/ui-resize-observer-directive';
import { injectWindow } from '@cosmos/util-common/di';
import {
  DataBusStateActionMessage,
  IframeDataBus,
} from '@cosmos/util-data-bus';
import { CustomerPortalIframeEncoreStateActions } from '@esp/presentations/types-customer-portal-iframe-actions';

/**
 * Listens to size changes of the content and notifies the host window about it.
 * This is needed for preview in host window to resize the previewer.
 */
export function listenToResizeAndNotifyHostWindow({
  content,
  dataBus,
}: {
  content: Signal<ElementRef<HTMLElement>>;
  dataBus?: IframeDataBus;
}) {
  const resizer = injectResizer();
  dataBus ??= new IframeDataBus({
    currentWindow: injectWindow(),
  });

  afterNextRender(() => {
    const contentElement = content()?.nativeElement;
    if (!contentElement) {
      return;
    }
    resizer(contentElement, (entry) => {
      dataBus.dispatch(
        new DataBusStateActionMessage(
          new CustomerPortalIframeEncoreStateActions.HeightChanged(
            entry.target.scrollHeight
          )
        )
      );
    });
  });
}
